// @flow
// eslint-disable-next-line
import bootstrap from "./bootstrap.js";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "app/redux/store";
// import './index.css';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { deviceFingerprintHash } from "./utils/DeviceFingerprint";

deviceFingerprintHash.then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  serviceWorker.unregister();
});
